export default __webpack_public_path__ + "static/media/yeopen_big.e701bd92.jpg";